import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";

export const ChangeEmailRegistrationMessage: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>メールアドレスの変更完了</TitleWrapper>

      <Message>メールアドレスを変更いたしました。</Message>
      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px;
  margin: 0 auto 80px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 43px 0 38px 0;
  display: flex;
  line-height: 1em;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const Message = styled.div`
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  margin-bottom: 320px;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    height: auto;
    line-height: 1;
    font-weight: bold;
  }
`;
